import React from "react";
import { Button, ButtonProps } from "antd";
import "./index.scss";

interface GradientButtonProps extends ButtonProps {
  onClick?: () => void;
  className?: string;
  size?: any;
}

const GradientButton: React.FC<GradientButtonProps> = ({
  onClick,
  children,
  className = "",
  size,
  ...restProps
}) => {
  return (
    <Button
      className={`gradient-button ${className}`}
      onClick={onClick}
      {...restProps}
    >
      {children}
    </Button>
  );
};

export default GradientButton;
